module.exports = __webpack_public_path__ + "img/sprinkle-5.cae019fe.webp";